import * as types from './types'
import * as actions from './actions'
import * as getters from './getters'

const state = {
  assistantStoreInfo: {
    storeId: null,
    storeName: ''
  },
  filterInfo: {}, // 学员列表/课程订单列表 筛选条件
  courseRichContent: '', // 添加课时图文详情
  classRequestParams: {} // 课程管理请求参数
}
const mutations = {
  // 存储筛选条件
  [types.SET_TEACH_ASSISTANT_INFO] (state, data) {
    console.log('存储筛选条件', data)
    state.filterInfo = {
      ...data
    }
  },
  // 存储课程图文详情
  [types.SET_COURSE_CONTENT] (state, data) {
    state.courseRichContent = data
  },
  // 存储当前选择的门店信息
  [types.SET_TEACH_ASSISTANT_STORE_INFO] (state, data) {
    state.assistantStoreInfo.storeId = data.storeId
    state.assistantStoreInfo.storeName = data.storeName
  },
  // 存储课程管理列表请求参数
  [types.SET_CLASS_LIST_REQUEST] (state, data) {
    state.classRequestParams = {
      ...state.classRequestParams,
      ...data
    }
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}
